import { createRequest } from "helpers/tools";

export const getEvents = async (tracker_id) => {
    return await createRequest({
        suffix: `tracker-event-configuration/${tracker_id}`,
        method: "get",
        handleError: false,
    });
};

export const updateEventStatus = async (tracker_id, event_id) => {
    return await createRequest({
        suffix: `tracker-event-configuration/${tracker_id}/${event_id}/updateEventStatus`,
        method: "put",
        payload: {},
        handleError: false,
    });
};

export const updatePiiStatus = async (tracker_id) => {
    return await createRequest({
        suffix: `tracker-event-configuration/${tracker_id}/updatePiiStatus`,
        method: "put",
        payload: {},
        handleError: false,
    });
};
